<template>
    <div class="topBar">
        <img class="logo" src="../assets/logo.png"/>
        <h1>Tanton Software Solutions</h1>
    </div>
</template>

<script>

export default ({
    name: 'TopBar',
    components: {
    },
    setup() {

    },
    created() {
    },
    data() {
        return {
        };
    },
    methods: {
    }
})
</script>

<style scoped>
.topBar {
  width: 100%;
  height: 80px;
  display: flex;
}
.topBar h1 {
    vertical-align: middle;
    padding-left:10px;
    text-align: left;
}
.logo {
    vertical-align: middle;
    width: 75px;
    height: 75px;
    padding: 5px;
}

</style>